module.exports = __webpack_public_path__ + "static/media/reverseportalorangeparrot.767b6f9d.gif";